<template>
    <div class="min-h-screen flex flex-col">
        
        <div class="w-60 fixed border-r px-6 shadow-sm h-screen bg-gray-50">
            <h1 class="font-bold text-2xl py-4 mb-4 text-primary">Design System</h1>

            <nav>
                <ul class="leading-loose">
                    <li><a href="#spacing">Spacing</a></li>
                    <li><a href="#typography">Typography</a></li>
                    <li><a href="#colors">Colors</a></li>
                    <li><a href="#icons">Icons</a></li>
                    <li><a href="#buttons">Buttons</a></li>
                    <li><a href="#form">Form</a></li>
                    <li><a href="#modal">Modals</a></li>
                    <li><a href="#links">Links</a></li>
                </ul>
            </nav>
        </div>

        <div class="w-full pl-72 py-4">
            <slot />
        </div>
    </div>
</template>

<script>

import { Link } from '@inertiajs/inertia-vue3';

export default {
    components: {
        Link,
    }
}
</script>
